export {default} from './Slider';
export type {ISliderProps, ISliderRef} from './types';
export {SliderDefaults} from './shared';
